import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Users/hooks/useUserGroups.ts
var testData = {
	total: 3,
	userGroups: [
		{
			color: "rgb(125,156,187)",
			description: "They walk, they stand; to protect and secure",
			id: "ID_01",
			organizationId: "AB1",
			title: "Patrol Officers"
		},
		{
			color: "#d66b1f",
			description: "They watch, they coordinate; keeping the ship afloat",
			id: "ID_02",
			organizationId: "AB1",
			title: "Supervisors"
		},
		{
			color: "#8bdc4a",
			description: "They plan, they plot; for profit",
			id: "ID_03",
			organizationId: "AB1",
			title: "Managers"
		}
	]
};
function useUserGroups(args, opts = {}) {
	const { data, isCalling } = useRPC(RPCs.Users.GetUserGroupsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args,
		testData
	});
	return {
		data,
		loading: isCalling
	};
}
//#endregion
export { useUserGroups };

//# sourceMappingURL=useUserGroups.js.map